import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

import { env } from '@/config/env';
import { createLink } from '@/helpers/links/createLink';
import theme from '@/theme';

import { OptionStatusUnion, PrizesBreakdownType } from '@/types/domain';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const linkToGZ = (lang: string) =>
  createLink({
    url: env.GAMEZONE_URL,
    searchParams: {
      lang,
    },
  });

export const bgColorByOptionStatus = {
  correct: theme.colors.answerButton.correctBg,
  incorrect: theme.colors.answerButton.incorrectBg,
  selection: theme.colors.answerButton.activeBg,
  selected: theme.colors.answerButton.activeBg,
  none: theme.colors.answerButton.bg,
  disabled: theme.colors.answerButton.bg,
} as Record<OptionStatusUnion, string>;

export const textColorByOptionStatus = {
  correct: theme.colors.answerButton.dark_text,
  incorrect: theme.colors.answerButton.dark_text,
  selection: theme.colors.answerButton.dark_text,
  selected: theme.colors.answerButton.dark_text,
  none: theme.colors.answerButton.white_text,
  disabled: theme.colors.answerButton.white_text,
} as Record<OptionStatusUnion, string>;

export const calcDayStreakToEarnPrize = (
  prizesBreakdown: PrizesBreakdownType[] | undefined,
) => {
  let counter = 0;
  (prizesBreakdown || [])?.map((x) => {
    if (!x.prizeText) counter++;
    return;
  });
  return counter;
};

export const TOKEN_LOGOUT = 'logout';

export const UNAUTHORIZED_ERROR_MESSAGE = '401';
